var _defs, _ellipse, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _ellipse2, _ellipse3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroceryEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 200,
    viewBox: "0 0 240 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "groceryEmptyBagGradient",
    x1: 75,
    y1: 110,
    x2: 165,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7579E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BD7E2"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 194,
    rx: 58,
    ry: 6,
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 150,
    r: 4,
    fill: "#CBCED5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 70,
    r: 3,
    fill: "#CBCED5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 150,
    r: 5,
    fill: "#FFEFB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,111 C100,86 140,86 140,111",
    stroke: "#7579E7",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75,111 L165,111 L155,185 C154.3,190.5 151,192 145,192 L95,192 C89,192 85.7,190.5 85,185 Z",
    fill: "url(#groceryEmptyBagGradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87,128 L153,128",
    stroke: "#FFFFFF",
    strokeOpacity: 0.35,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120,109 C120,96 118,86 120,73",
    stroke: "#61D79C",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 87,
    rx: 11,
    ry: 6.5,
    transform: "rotate(-28 110 87)",
    fill: "#61D79C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 79,
    rx: 11,
    ry: 6.5,
    transform: "rotate(28 130 79)",
    fill: "#95E3BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 26,
    width: 72,
    height: 56,
    rx: 12,
    fill: "#F6F6F6",
    stroke: "#CBCED5",
    strokeWidth: 1.5,
    strokeDasharray: "4 5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 42,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 55,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 68,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 26,
    r: 12,
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,20 L224,32 M218,26 L230,26",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryEmpty);
export default __webpack_public_path__ + "static/media/grocery_empty.cc6157432cffdea481e26c2f1487416b.svg";
export { ForwardRef as ReactComponent };